import { render, staticRenderFns } from "./Ryzen.vue?vue&type=template&id=5bfe48ce&scoped=true&"
import script from "./Ryzen.vue?vue&type=script&lang=js&"
export * from "./Ryzen.vue?vue&type=script&lang=js&"
import style0 from "./Ryzen.vue?vue&type=style&index=0&id=5bfe48ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfe48ce",
  null
  
)

export default component.exports